module.exports = __webpack_public_path__ + "media/images/landing/icon-dotted-line-7653b34509b7f1a276c28edd15efb94e.svg";